import { ProductCodeEnum } from "enums";
import { prettifyProductCode } from "utils/pretty.utils";

export const STATION_TYPE_OPTIONS = [
  { label: "COCO", value: "COCO" },
  { label: "COXO", value: "COXO" },
  { label: "CODO", value: "CODO" },
  { label: "DODO", value: "DODO" },
  { label: "DODOX", value: "DODOX" },
  { label: "WILCO", value: "WILCO" },
  { label: "UWIDOX", value: "UWIDOX" },
  { label: "COCO (EXPRESS)", value: "COCO (EXPRESS)" },
  { label: "COCO (MICRO)", value: "COCO (MICRO)" },
  { label: "CODOL", value: "CODOL" },
  { label: "UDODOX", value: "UDODOX" },
  { label: "WIBCO", value: "WIBCO" },
  { label: "WIDOX", value: "WIDOX" },
  { label: "WILCO AR", value: "WILCO AR" },
  { label: "XWIDO", value: "XWIDO" },
];

export const ISLAND_OPTIONS = [
  { label: "LUZON", value: "Luzon" },
  { label: "VISAYAS", value: "Visayas" },
  { label: "MINDANAO", value: "Mindanao" },
];

export const PROVINCES_BY_ISLAND = {
  Luzon: [
    "Metro Manila", "Abra", "Apayao", "Aurora", "Bataan", "Batanes",
    "Benguet", "Bulacan", "Cagayan", "Camarines Norte", "Camarines Sur",
    "Catanduanes", "Cavite", "Ifugao", "Ilocos Norte", "Ilocos Sur",
    "Isabela", "Kalinga", "La Union", "Laguna", "Leyte", "Marinduque",
    "Masbate", "Mountain Province", "Nueva Ecija", "Nueva Vizcaya",
    "Occidental Mindoro", "Oriental Mindoro", "Palawan", "Pampanga",
    "Pangasinan", "Quezon", "Quirino", "Rizal", "Romblon", "Sorsogon",
    "Tarlac", "Zambales",
  ],
  Visayas: [
    "Aklan", "Antique", "Biliran", "Bohol", "Capiz", "Cebu",
    "Eastern Samar", "Guimaras", "Iloilo", "Leyte", "Negros Occidental",
    "Negros Oriental", "Northern Samar", "Samar", "Siquijor", "Southern Leyte",
  ],
  Mindanao: [
    "Agusan del Norte", "Agusan del Sur", "Basilan", "Bukidnon", "Camiguin",
    "City of Isabela", "Compostela Valley", "Cotabato", "Davao de Oro",
    "Davao del Norte", "Davao del Sur", "Davao Occidental", "Davao Oriental",
    "Dinagat Islands", "Lanao del Norte", "Lanao del Sur",
    "Maguindanao del Norte", "Maguindanao del Sur", "Misamis Occidental",
    "Misamis Oriental", "North Cotabato", "Sarangani", "South Cotabato",
    "Sultan Kudarat", "Sulu", "Surigao del Norte", "Surigao del Sur",
    "Tawi-Tawi", "Zamboanga del Norte", "Zamboanga del Sur",
    "Zamboanga Sibugay",
  ],
};

export const ALL_PRODUCT_CODES = [
  ProductCodeEnum.DIESEL,
  ProductCodeEnum.GAS91,
  ProductCodeEnum.GAS95,
  ProductCodeEnum.GAS97,
  ProductCodeEnum.GAS105,
  ProductCodeEnum.KEROSENE,
  ProductCodeEnum.LPG,
];

export const PRODUCT_OPTIONS = ALL_PRODUCT_CODES.map((code) => ({
  label: prettifyProductCode(code),
  value: code,
}));

export const DEFAULT_PRODUCTS = [ProductCodeEnum.DIESEL, ProductCodeEnum.GAS91];
